import { publicDir } from "../../config/config";
import CopyrightFooter from "./CopyrightFooter";

export default function LoginIntro() {
  return <>
    <img className="PA__logo mx-auto" src={publicDir("/assets/images/logo/logo.png")} alt="SIT Logo" />
    <h1>Welcome to GROW-Pro</h1>
    <h2>Your AI-enabled coaching platform for you to grow professional traits, reflect on workplace learning experiences, and gain valuable mentor feedback during your integrated Work Study Programme journey!</h2>
    <img className="PA__img mx-auto" src={publicDir("/assets/images/auth-image.png")} alt="" />
    <div className="text-center mt-5 copyright__auth--desktop">
      <CopyrightFooter align="center" />
    </div>
  </>;
}
